module.exports = __webpack_public_path__ + "img/icon_help_document.45cfeea8.svg";